import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { accountsAdapter } from './accounts';

const accountsState = (state: RootState) => state?.accounts;

export const selectedAccountSelector = createSelector([accountsState], (state) => state.selectedAccount);

export const selectedAccStateSelector = createSelector([accountsState], (state) => ({
  ...state,
  subaccounts: accountsAdapter.getSelectors().selectAll(state.subaccounts),
  loading: state.loadingPending > 0,
}));

export const userMainAccStateSelector = createSelector([accountsState], (state) => state?.userMainAccount);

//

const profileState = (state: RootState) => state.userProfile;

export const selectUserStateSelector = createSelector([profileState], (state) => ({
  ...state,
  loading: state.loadingPending > 0,
}));
